import cache from '@/common/js/cache'
import * as storageKey from '@/common/js/const'
import store from "./index";

export const user = state => {
  if (state.user)
    return state.user;
  let data = cache.get(storageKey.storage_user, null);
  if (data)
    store.dispatch('userInit', data);
  return data;
}

export const token = state => {
  if (state.token)
    return state.token;
  let data = cache.get(storageKey.storage_user, null);
  if (data)
    store.dispatch('userInit', data);
  return cache.get(storageKey.storage_token, null);
}




// WEBPACK FOOTER //
// ./src/store/getters.js